var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31556_5194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 17.4998L9.6665 19.9998M9.6665 19.9998L12.1665 22.4998M9.6665 19.9998H26.3332M15.4998 14.1665L17.9998 11.6665M17.9998 11.6665L20.4998 14.1665M17.9998 11.6665V28.3332M20.4998 25.8332L17.9998 28.3332M17.9998 28.3332L15.4998 25.8332M23.8332 17.4998L26.3332 19.9998M26.3332 19.9998L23.8332 22.4998",
    stroke: "#535862",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31556_5194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.571d46268c48384a535de58fec9c0e3f.svg";
export { ForwardRef as ReactComponent };